import { render, staticRenderFns } from "./CommonItem.vue?vue&type=template&id=6a23bfdd"
import script from "./CommonItem.vue?vue&type=script&lang=js"
export * from "./CommonItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports